import { useEffect } from "react"
import Hero from './../../components/Hero'
import Services from './../../components/Services'
import Recommend from './../../components/Recommend'
import Testimonials from './../../components/Testimonials';
import ReactMapGL, { Marker, NavigationControl, Popup } from "react-map-gl";
import 'mapbox-gl/dist/mapbox-gl.css'
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { useState } from "react";
import { Link } from "react-router-dom";
import scrollreveal from 'scrollreveal'
import { Box } from '@mui/material'
import axios from 'axios';
import defaultImg from './../../../admin/assets/images/default.png'
import mapboxgl from 'mapbox-gl';
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

const Home = () => {
  const PF = process.env.REACT_APP_FIND_API_URL + '/images/'
  const [viewport, setViewport] = useState({});
  const [dataId, setDataId] = useState(null);
  const [search, setSearch] = useState();
  const [data, setData] = useState([])
  useEffect(() => {
    navigator.geolocation.getCurrentPosition((pos) => {
      setViewport({
        ...viewport,
        latitude: pos.coords.latitude,
        longitude: pos.coords.longitude,
        zoom: 10,
      });
    });
  }, [viewport]);

  const handlepopup = (id) => {
    setDataId(id)
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    // e.stopPropagagtion();
  }

  useEffect(() => {
    axios.post(process.env.REACT_APP_FIND_API_URL + `/store-products/search-products`, { name: search }, {withCredentials: true}).then((res) => {
      let data = res.data;
      const newArr = data.map((d) => {
        const { seller_store_map_location, service_provider_map_location, ...temp } = d;
        var returnObj
        if (service_provider_map_location === null) {
          const loc = JSON.parse(seller_store_map_location);
          const l = {
            latitude: loc[0],
            longitude: loc[1]
          }
          returnObj = {
            ...temp,
            ...l
          }
        } else {
          const loc = JSON.parse(service_provider_map_location);
          const l = {
            latitude: loc[0],
            longitude: loc[1]
          }
          returnObj = {
            ...temp,
            ...l
          }
        }
        return returnObj
      })
      console.log(newArr);
      setData(newArr)
    }).catch((err) => {
      console.log(err);
    })
  }, [search])

  // const mapRef = useRef();

  // useEffect(()=> {
  //   fetch('https://ipapi.co/json').then((res)=> {
  //     return res.json()
  //   }).then((data)=> {
  //     mapRef.current.flyTo({
  //       center: [data.longitude, data.latitude]
  //     });
  //     setViewport({...viewport, longitude: data.longitude, latitude: data.latitude})
  //   })
  // }, [])

  useEffect(() => {
    const sr = scrollreveal({
      origin: "top",
      distance: "80px",
      duration: 2000,
      reset: true,
    });
    sr.reveal(
      `
        #hero,
        #services,
        #recommend,
        #testimonials,
        `,
      {
        opacity: 0,
        interval: 300,
      }
    );
  }, []);


  return (
    <>


      {

        viewport.latitude && viewport.longitude ? (
          <Box sx={{ height: 800, position: 'relative' }}>
            <div className="position-absolute w-100 h-100">
              <Row className="d-flex justify-content-center w-100 m-auto" style={{ position: 'relative', bottom: '-50px', zIndex: '1000' }}>
                <Col md={8} className='justify-content-end'>
                  <Form onSubmit={handleSubmit} className='w-75 m-auto'>
                    <Row className="align-items-center justify-content-end">
                      <Col md={8}>
                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                          <Form.Label>Search Products</Form.Label>
                          <Form.Control type="text" placeholder="Enter anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                        </Form.Group>
                      </Col>
                      {/* <Col className="mt-3" md={6}> */}
                      {/* </Col> */}
                    </Row>
                  </Form>
                </Col>
                <Col md={1} className="bg-white py-3 px-2 d-flex align-items-center flex-column" style={{ fontSize: '10px', width: '200px' }}>
                  <p className=" fw-bold">Discounted Items: <i class='bx bxs-store-alt fs-5 discountedMarker'></i></p>
                  <p className=" fw-bold">Non Discounted Items: <i class='bx bxs-store-alt fs-5 fw-bold simpleMarker'></i></p>
                </Col>
              </Row>
              {viewport.latitude && viewport.longitude && (
                <div>
                  <ReactMapGL
                    mapboxAccessToken="pk.eyJ1Ijoic2hhaWJpIiwiYSI6ImNraGxqajRyeDB1M3oyd3MyaXE4MG0xZ20ifQ.PY_b9Dadqa6TmtUouX86Gw"
                    initialViewState={viewport}
                    mapStyle="mapbox://styles/mapbox/streets-v9"
                    style={{ position: "absolute" }}
                  >
                    <NavigationControl position="bottom-right" />
                    <Marker
                      longitude={viewport.longitude}
                      latitude={viewport.latitude}
                      style={{ cursor: 'pointer' }}
                      offsetLeft={-20}
                      offsetTop={-10}
                    >
                      <i class='bx bxs-map fs-3'></i>
                      <div className="bg-white p-3 rounded">You are here</div>
                    </Marker>
                    {
                      data?.map((data, index) => (
                        <>
                          <Marker
                            longitude={data.longitude}
                            latitude={data.latitude}
                            style={{ cursor: 'pointer' }}
                            offsetLeft={-20}
                            offsetTop={-10}
                            key={index}
                          >
                            <i
                              class={`bx bxs-store-alt fs-2 ${Number(data.discounted_price) > 0 ? 'discountedMarker' : 'simpleMarker'}`} onClick={() => handlepopup(data.id)}></i>
                          </Marker>
                          {
                            data?.id === dataId &&
                            <Popup
                              latitude={31.474884} longitude={74.440827} closeButton={true} closeOnClick={false} anchor="top" >
                              <Link to={`/product/${data.id}`}>
                                <Card className="position-absolute" style={{ width: '18rem' }}>
                                  <Card.Img variant="top" src={data.images === null ? defaultImg : PF + data.images} />
                                  <Card.Body>
                                    <Card.Title className="text-center fs-2">{data.name}</Card.Title>
                                    <Card.Text>
                                      <p>{data.product_name}</p>
                                      <div className="d-flex justify-content-center gap-1 align-items-center">
                                        <span className={`${Number(data.discounted_price) > 0 ? 'text-decoration-line-through' : ''} fs-4 `}>{data.price}</span>
                                        <span className="text-danger fs-6 mt-2">{Number(data.discounted_price) > 0 ? ( data.price - data.discounted_price ) === 0 && "Free" : ""}</span>
                                      </div>
                                    </Card.Text>
                                    <Card.Footer>{data.seller_store_name}</Card.Footer>
                                  </Card.Body>
                                </Card>
                              </Link>
                            </Popup>
                          }
                        </>))
                    }
                  </ReactMapGL>

                </div>

              )}

            </div>

          </Box>

        )
          :
          <Hero />
      }


      
      <Services />
      <Recommend />
      {/* <Testimonials /> */}
    </>
  )
}

export default Home
